import { AxiosError } from 'axios'

export function isObject(target: unknown): target is Record<string, unknown> {
  return typeof target === 'object' && target !== null
}

export function isAxiosError(target: unknown): target is AxiosError {
  return !!target && isObject(target) && 'isAxiosError' in target && !!target.isAxiosError
}

export function isPresent<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined
}

export function unwrapMaybe<T>(value: T | null | undefined): T | undefined {
  return isPresent(value) ? value : undefined
}
